import { render, staticRenderFns } from "./serialNumberSelectionModel.vue?vue&type=template&id=1bfdfca4&lang=html"
import script from "./serialNumberSelectionModel.vue?vue&type=script&lang=js"
export * from "./serialNumberSelectionModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports